module.exports = __webpack_public_path__ + "static/media/intensity-of-emotions.f5c45bd4.png";